module.exports = __webpack_public_path__ + "img/1559563591.4ebf8a2a.jpg";